import { render, staticRenderFns } from "./PaymentSettlementForm.vue?vue&type=template&id=335ddbf4&scoped=true"
import script from "./PaymentSettlementForm.vue?vue&type=script&lang=js"
export * from "./PaymentSettlementForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentSettlementForm.vue?vue&type=style&index=0&id=335ddbf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ddbf4",
  null
  
)

export default component.exports